[
  {
    "code": "DO-02",
    "name": "Azua"
  },
  {
    "code": "DO-03",
    "name": "Bahoruco"
  },
  {
    "code": "DO-04",
    "name": "Barahona"
  },
  {
    "code": "DO-05",
    "name": "Dajabón"
  },
  {
    "code": "DO-01",
    "name": "Distrito Nacional (Santo Domingo)"
  },
  {
    "code": "DO-06",
    "name": "Duarte"
  },
  {
    "code": "DO-08",
    "name": "El Seybo"
  },
  {
    "code": "DO-09",
    "name": "Espaillat"
  },
  {
    "code": "DO-30",
    "name": "Hato Mayor"
  },
  {
    "code": "DO-10",
    "name": "Independencia"
  },
  {
    "code": "DO-11",
    "name": "La Altagracia"
  },
  {
    "code": "DO-07",
    "name": "La Estrelleta"
  },
  {
    "code": "DO-12",
    "name": "La Romana"
  },
  {
    "code": "DO-13",
    "name": "La Vega"
  },
  {
    "code": "DO-14",
    "name": "María Trinidad Sánchez"
  },
  {
    "code": "DO-28",
    "name": "Monseñor Nouel"
  },
  {
    "code": "DO-15",
    "name": "Monte Cristi"
  },
  {
    "code": "DO-29",
    "name": "Monte Plata"
  },
  {
    "code": "DO-16",
    "name": "Pedernales"
  },
  {
    "code": "DO-17",
    "name": "Peravia"
  },
  {
    "code": "DO-18",
    "name": "Puerto Plata"
  },
  {
    "code": "DO-19",
    "name": "Salcedo"
  },
  {
    "code": "DO-20",
    "name": "Samaná"
  },
  {
    "code": "DO-21",
    "name": "San Cristóbal"
  },
  {
    "code": "DO-31",
    "name": "San José de Ocoa"
  },
  {
    "code": "DO-22",
    "name": "San Juan"
  },
  {
    "code": "DO-23",
    "name": "San Pedro de Macorís"
  },
  {
    "code": "DO-25",
    "name": "Santiago"
  },
  {
    "code": "DO-26",
    "name": "Santiago Rodríguez"
  },
  {
    "code": "DO-32",
    "name": "Santo Domingo"
  },
  {
    "code": "DO-24",
    "name": "Sánchez Ramírez"
  },
  {
    "code": "DO-27",
    "name": "Valverde"
  }
]